import { render, staticRenderFns } from "./StylistsOtherInq.vue?vue&type=template&id=17640b6c&scoped=true"
import script from "./StylistsOtherInq.vue?vue&type=script&lang=js"
export * from "./StylistsOtherInq.vue?vue&type=script&lang=js"
import style0 from "./StylistsOtherInq.vue?vue&type=style&index=0&id=17640b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17640b6c",
  null
  
)

export default component.exports